<template lang="pug">
  .layout-view
    .layout-view__controls 
      v-btn.mr-2(
        :yellow="hasFilters"
        medium
        @click="modals.showFilters = true")
        v-icon(
          position-left
          font-size="1"
          icon="filter").mr-1
        span {{ 'reports.add_filters' | translate }}
      v-btn(
        medium
        :loading="loading"
        :disabled="!totalCount"
        @click.native="getReport()")
        v-icon(
          position-left
          font-size="1"
          icon="file-download")
        span {{ 'reports.create_report' | translate }}
    report-tabs
    v-dialog(
      max-width="450"
      v-model="modals.showFilters")
      filters-modal(
        @close="modals.showFilters = false")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FileSaver from 'file-saver'
import ReportTabs from '../common/ReportTabs'
import FiltersModal from './modals/FiltersModal'

export default {
  name: 'ReportsHeader',

  components: {
    ReportTabs,
    FiltersModal
  },

  data: () => ({
    modals: {
      showFilters: false
    },
    loading: false
  }),

  computed: {
    ...mapGetters('kkzreports', [
      // 'totalCount'
    ]),
    ...mapGetters('reports', [
      // 'load',
      'filters',
      'hasFilters',
      'totalCount'
    ]),
  },

  methods: {
    ...mapActions('kkzreports', [
      'makeReport',
      'applyFilters'
    ]),

    async getReport () {
      this.loading = true
      this.applyFilters(this.filters)
      this.downloadReport(await this.makeReport())
      this.loading = false
    },

    b64toFile (b64Data, filename, contentType) {
      const sliceSize = 512
      const byteCharacters = atob(b64Data)
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)
        const byteNumbers = new Array(slice.length)

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }
      return new File(byteArrays, filename, {type: contentType})
    },

    downloadReport ({ report, name }) {
      const file = this.b64toFile(report, name, 'application/vnd.ms-excel;charset=utf-8')
      FileSaver.saveAs(file, name)
    }
  }
}
</script>
